const NATIVE_INTERACTIVE = new Set(['button', 'a', 'input', 'textarea', 'select']);

const setModality = (modality: 'keyboard' | 'pointer') => {
	document.documentElement.dataset.inputModality = modality;
};

const handleModalityKeyDown = (event: KeyboardEvent) => {
	if (event.key === 'Tab') setModality('keyboard');
};

const isActivationKey = (event: KeyboardEvent) => event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';

const handleActivationKeyDown = (event: KeyboardEvent) => {
	if (!isActivationKey(event)) return;

	const target = event.target as Element | null;
	const control = target?.closest('[role="button"]') as (Element & { click?: () => void }) | null;
	if (!control) return;

	if (NATIVE_INTERACTIVE.has(control.tagName.toLowerCase())) return;
	if (control.getAttribute('aria-disabled') === 'true') return;

	event.preventDefault();
	control.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
};

export const setupA11y = () => {
	if (typeof window === 'undefined') return;

	setModality('pointer');
	window.addEventListener('keydown', handleModalityKeyDown, true);
	window.addEventListener('pointerdown', () => setModality('pointer'), true);
	window.addEventListener('keydown', handleActivationKeyDown);
};
